import React, { useState } from 'react';

const services = [
  'North America Consulting',
  'Databricks Consulting',
  'Power Platform',
  'AI Consulting (OpenAI / Claude)',
  'Other',
];

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', service: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <section id="contact" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Left: Info */}
          <div>
            <span className="inline-block bg-blue-100 text-primary text-sm font-semibold px-3 py-1 rounded-full mb-4">
              📬 Get In Touch
            </span>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Let's Start a Conversation
            </h2>
            <p className="text-gray-500 text-lg mb-8 leading-relaxed">
              Whether you're planning a Databricks migration, a Power Platform deployment, or an AI pilot project — we'd love to hear about your goals and explore how we can help.
            </p>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg">📧</div>
                <div>
                  <div className="font-semibold text-gray-800">Email</div>
                  <a href="mailto:info@SpikedQcumber.com" className="text-primary hover:underline">
                    info@SpikedQcumber.com
                  </a>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg">📍</div>
                <div>
                  <div className="font-semibold text-gray-800">Locations</div>
                  <div className="text-gray-500">Toronto</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="bg-primary text-white w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-lg">🕐</div>
                <div>
                  <div className="font-semibold text-gray-800">Response Time</div>
                  <div className="text-gray-500">We respond within 1 business day</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Form */}
          <div className="bg-white rounded-2xl shadow-lg p-8">
            {submitted ? (
              <div className="text-center py-12">
                <div className="text-6xl mb-4">✅</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Message Received!</h3>
                <p className="text-gray-500">Thank you for reaching out. A consultant will be in touch within 1 business day.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Jane Smith"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Work Email *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={form.email}
                    onChange={handleChange}
                    placeholder="jane@company.com"
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Service Interest</label>
                  <select
                    name="service"
                    value={form.service}
                    onChange={handleChange}
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition bg-white"
                  >
                    <option value="">Select a service...</option>
                    {services.map(s => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">Message *</label>
                  <textarea
                    name="message"
                    required
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us about your project or challenge..."
                    className="w-full border border-gray-200 rounded-xl px-4 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition resize-none"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-primary text-white py-3 rounded-xl font-bold hover:bg-blue-900 transition-colors text-lg"
                >
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
